import styled from 'styled-components'

export const AvatarStyled = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 999rem;
  border: 1.37838px solid #ffffff;
  filter: drop-shadow(0px 2.75676px 13.0946px rgba(64, 64, 64, 0.17));
`
